const round = (numero, decimales = 2) => {
  const valor1 = Math.round((numero + Number.EPSILON) * Math.pow(10, decimales + 1)) / Math.pow(10, decimales + 1)
  const valor2 = Math.round((valor1 + Number.EPSILON) * Math.pow(10, decimales)) / Math.pow(10, decimales)

  return +valor2.toFixed(decimales)
}

const roundTwoDecimals = (num) => {
  const m = Number((Math.abs(num) * 100).toPrecision(15))
  return Math.round(m) / 100 * Math.sign(num)
}


export default Object.freeze({
  round,
  roundTwoDecimals
})
